import styled from '@emotion/styled';
import { breakpoints, colors, spacing } from '../../../utils/styleguide';
import { Col, Row } from '../layout/12ColGridLayout';

import Typography from '../text/Typography';

const LabelRow = styled(Row)`
  padding: ${spacing[3]}px 0;
`;

const ValueRow = styled(Row)`
  padding: ${spacing[3]}px 0;
  background-color: ${colors.brightGray};
`;
const Value = styled(Typography)`
  margin-left: ${spacing[5]}px;
  ${breakpoints.tablet} {
    margin-left: 0;
  }
`;

const AccountInfoSection = ({ label, value }: { label: string; value: string }) => (
  <>
    <LabelRow>
      <Col>
        <Typography variant="h5">{label}</Typography>
      </Col>
    </LabelRow>
    <ValueRow noMargin>
      <Col>
        <Value variant="bodySmall">{value}</Value>
      </Col>
    </ValueRow>
  </>
);

export default AccountInfoSection;
